import CityPageTemplate from "../city-template/CityPageTemplate";
import { noblesvilleConfig } from "./data";

export default function NoblesvillePage() {
  return <CityPageTemplate config={noblesvilleConfig} />;
}